// extracted by mini-css-extract-plugin
export default {"welcome":"Welcome_welcome__EM2vX","important":"Welcome_important__JNtnx"};